import Vue from 'vue'

import VuePagination2 from 'vue-pagination-2'
Vue.component('Pagination', VuePagination2)
